/**
 * addAccordionFooterMarkup
 */

// Store headingTagName globally
let headingTagName;
window.addEventListener('DOMContentLoaded', (event) => {
    // Select the first .is-style-collapsible heading
    const heading = document.querySelector('.footer-top .is-style-collapsible');
    if (heading && !headingTagName) {
        headingTagName = "h3";
    }
});

/**
 * addAccordionsFooterMarkup
 */
function addAccordionsFooterMarkup() {
    const headings = document.querySelectorAll('.footer-top .is-style-collapsible');

    headings.forEach((heading, index) => {
        const button = document.createElement('button');

        // Start with the 'accordion-toggle' class
        let classes = ['accordion-toggle'];
        // Loop through the headings to collect classes
        headings.forEach(heading => {
            let headingClasses = Array.from(heading.classList);
            classes = classes.concat(headingClasses);
        });

        // Remove duplicate classes
        classes = [...new Set(classes)];
        button.className = classes.join(' ');
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = heading.innerHTML;
        button.id = `accordion-toggle-${index}`;
        heading.parentNode.insertBefore(button, heading);
        heading.remove();
        var ulElement = button.nextElementSibling;
        ulElement.classList.add('accordion-content');
    });
}

/**
 * removeAccordionsFooterMarkup
 */
function removeAccordionsFooterMarkup() {
    const buttons = document.querySelectorAll('.footer-top .accordion-toggle');

    buttons.forEach((button) => {
        const heading = document.createElement(headingTagName);
        heading.className = button.className;
        heading.classList.remove('accordion-toggle');
        heading.innerHTML = button.innerHTML;
        button.parentNode.insertBefore(heading, button);
        button.remove();
        var ulElement = heading.nextElementSibling;
        ulElement.classList.remove('accordion-content');
    });
}

/**
 * initAccordionsFooter
 */
function initAccordionsFooter() {
    const accordion = document.querySelectorAll('.footer-top .accordion-toggle');
    for (let i = 0; i < accordion.length; i++) {
        accordion[i].onclick = function () {
            this.classList.toggle('is-active');
            this.nextElementSibling.classList.toggle('is-active');

            if (this.getAttribute('aria-expanded') === 'true') {
                this.setAttribute('aria-expanded', 'false');
            } else {
                this.setAttribute('aria-expanded', 'true');
            }
        };
    }
}

/**
 * destroyAccordionsFooter
 */
function destroyAccordionsFooter() {
    const accordions = document.querySelectorAll('.footer-top .accordion-toggle');
    for (let i = 0; i < accordions.length; i++) {
        accordions[i].onclick = null;
    }
}

/**
 * Remove all active classes
 */
function removeAllActiveClasses() {
    const activeElements = document.querySelectorAll('.footer-top .accordion-toggle');
    activeElements.forEach(element => {
        element.classList.remove('is-active');
        if (element.hasAttribute('aria-expanded')) {
            element.setAttribute('aria-expanded', 'false');
        }
        const nextElement = element.nextElementSibling;
        if (nextElement) {
            nextElement.classList.remove('is-active');
        }
    });
}

function initializeAccordionsFooter() {
    if (window.innerWidth <= 781) {
        removeAllActiveClasses();
        addAccordionsFooterMarkup();
        initAccordionsFooter();
    } else {
        removeAllActiveClasses();
        removeAccordionsFooterMarkup();
        destroyAccordionsFooter();
    }
}

document.addEventListener('DOMContentLoaded', function () {
    initializeAccordionsFooter();
});

window.onresize = function () {
    initializeAccordionsFooter();
};
